import React from "react";
import { Ruler, ChevronRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { useApp } from "../context/AppContext";
import { mediaSrc } from "../api";

/** "Which opening do you want to edit?" — for measurement catalogs (several openings in one message). */
export function CatalogEditPicker({ message, onPick, onClose }) {
  const { t } = useApp();
  if (!message) return null;
  const items = message.meta?.items || [];
  const photos = (message.media_ids || []).map((id) => (message.media || []).find((m) => m.id === id));
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="catalog-edit-picker">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <Ruler className="h-5 w-5 text-primary" /> {t("measure_pick_unit_edit")}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-1.5 max-h-[60vh] overflow-y-auto">
          {items.map((it, i) => {
            const editable = !!it.src?.media_id;
            return (
              <button
                key={i}
                type="button"
                disabled={!editable}
                data-testid={`catalog-edit-item-${i}`}
                onClick={() => onPick(i)}
                className="w-full flex items-center gap-2.5 rounded-xl border px-2.5 py-2 text-left hover:bg-muted/60 disabled:opacity-50 transition-colors"
              >
                {photos[i] ? (
                  <img src={mediaSrc(photos[i])} alt="" className="h-12 w-12 rounded-lg object-cover border shrink-0" />
                ) : (
                  <span className="h-12 w-12 rounded-lg border bg-muted shrink-0" />
                )}
                <span className="min-w-0 flex-1">
                  <span className="block text-sm font-semibold truncate">{i + 1}. {it.location || it.label || t("measurement")}</span>
                  <span className="block text-xs font-mono-plex text-muted-foreground truncate">{it.value}{it.subtype ? ` · ${it.subtype}` : ""}</span>
                </span>
                <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
              </button>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
}
